import DeliveryStatusIcon from "@redotech/redo-icons/truck-01.svg";
import { ShipmentTrackerStatus } from "@redotech/redo-model/fulfillments/outbound-shipment-label";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { formatSentenceCase } from "@redotech/util/string";

export const DeliveryStatusFilter: ArrayStringTableFilter = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "delivery status",
  itemLabelPlural: "delivery statuses",
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "deliveryStatus",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: DeliveryStatusIcon,
  values: Object.values(ShipmentTrackerStatus),
  display: (status: string) => {
    return formatSentenceCase(status.replace(/_/g, " "));
  },
  dbSearch: false,
  displayName: "Delivery Status",
};
